import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { userListQuery } from "@/app/Users/GraphQL/userListQuery";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
} from "@/components/catalyst/dropdown";
import { Avatar } from "@/components/catalyst/avatar";
import { getInitials } from "@/lib/Utils/getInitials";

interface Props {
  userId: string | undefined;
  onUserChange: (userId: string | undefined) => void;
}

export function SalesUserSelector({ userId, onUserChange }: Props) {
  const { data, isLoading } = useGqlQuery(userListQuery, {
    first: 50,
    page: 1,
  });

  const users = data?.users.data ?? [];
  const selected = users.find((u) => u.id === userId);

  if (isLoading) {
    return <div className="h-10 w-48 animate-pulse rounded-md bg-gray-200" />;
  }

  return (
    <Dropdown>
      <DropdownButton
        as="div"
        className="flex h-10 w-48 cursor-pointer items-center rounded-md border border-gray-300 bg-white px-3 hover:bg-gray-50"
      >
        {selected ? (
          <div className="flex items-center gap-2 truncate">
            <Avatar
              media={selected.profilePicture}
              initials={getInitials(selected.name ?? "--")}
              className="h-6 w-6 shrink-0 bg-purple-500 text-white"
            />
            <span className="truncate text-sm">{selected.name}</span>
          </div>
        ) : (
          <span className="text-sm text-gray-500">Select user</span>
        )}
      </DropdownButton>
      <DropdownMenu className="min-w-48" anchor="bottom start">
        {users.map((user) => (
          <DropdownItem key={user.id} onClick={() => onUserChange(user.id)}>
            <Avatar
              media={user.profilePicture}
              initials={getInitials(user.name ?? "--")}
              className="mr-2 h-6 w-6 shrink-0 bg-purple-500 text-white"
            />
            <DropdownLabel>{user.name}</DropdownLabel>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
